var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back-to-list"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }